<template>
  <div class="list-wrapper" :class="{ 'list-interaction' : interaction}">
    <ul class="scrollable">
      <li
        v-for="(entry, index) in gridData"
        :key="index"
        :class="{ disabled: disable(entry) }"
      >
        <div v-for="key in columns" :key="key" :class="key">
          <div class="img-column" v-if="key === 'pages'">
            <page-image-avatar :page="entry.page" v-if="name !== 'pages'"/>
            <page-image-avatar :page="entry" v-else/>
          </div>
          <p class="txt" v-else>{{entry.name}}</p>
        </div>
        <div class="btn-wrapper">
          <div>
            <vs-button
              class="add-btn btn-img"
              color="#2F1937"
              vs-type="filled"
              @click="post(entry.id)"
              v-if="interaction === true && getUserPlan"
            >
              <p>{{$t('dash.button.post')}}</p>
              <img src="../../assets/img/icon_more.svg" alt="search">
            </vs-button>
            <vs-button
              color="#a9a9a9"
              vs-type="border"
              @click="edit(entry.id)"
            >{{$t('dash.button.edit')}}</vs-button>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import PageImageAvatar from './PageImageAvatar.vue'
import User from '../mixins/User'

export default {
  name: 'component-list',

  components: {
    PageImageAvatar
  },

  mixins: [User],

  props: {
    gridData: Array,
    columns: Array,
    interaction: Boolean,
    name: String,
    disable: Function
  },

  methods: {
    /**
     * Add action on click
     * @param {Number} index - Index invoice to download
     */
    post(index) {
      this.$emit('post-clicked', index)
    },

    /**
     * Add action on click
     * @param {Number} index - Index invoice to download
     */
    edit(index) {
      if (this.name !== 'posts') {
        // Pages table
        this.$emit('edit-pages', 'pages')
      } else {
        // Posts table
        this.$emit('edit-posts', index)
      }
    }
  }
}
</script>
